import TruckInspectionModal from './TruckInspectionModal';
export default TruckInspectionModal;
